import { TertiaryButton } from "components/Button";
import { useAddToSession } from "features/Resources/Meeting/hooks";
import { Meeting } from "features/Resources/Meeting/models";

interface SelectOrRemoveButtonProps {
  meeting?: Meeting;
  eventId: string;
}

export default function SelectSessionButton({ meeting, eventId }: SelectOrRemoveButtonProps) {
  const { mutate: addToSession, isPending } = useAddToSession(meeting?.id ?? "");
  return <TertiaryButton
    h="28px"
    isLoading={isPending}
    onClick={() => addToSession({ eventId })}
    isDisabled={meeting?.calendarEventId === eventId}
  >
    {meeting?.calendarEventId === eventId ? "Current" : "Select"}
  </TertiaryButton>;
}
